import { render, staticRenderFns } from "./TravelQuoteSummary.vue?vue&type=template&id=32b4f11d"
import script from "./TravelQuoteSummary.vue?vue&type=script&lang=js"
export * from "./TravelQuoteSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports